import { useLocation } from "react-router-dom";
import CustomTitle from "../../../../components/CustomMiscellaneous/CustomTitle";
import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../../../services/api.service";
import TableView from "../../../Common/TableView";
import { ConvencionaisConfig } from "./Convencionais.config";

export default function Convencionais() {


    const location = useLocation();
    const currentRoute = location.pathname;
    const obraId = currentRoute.split("/")[2];
    const pecaId = currentRoute.split("/")[4];

    const EXTENSION = `/obras/${obraId}/pecas/${pecaId}/operacoes/Convencionais`;

    return(<>{EXTENSION?<div>
        <CustomTitle small text={'Operações Convencionais'}/>
        <TableView 
        title={"Operações de Convencionais"}
        postEntity={genericPost(EXTENSION)}
        editEntity={genericUpdate(EXTENSION)}
        deleteEntity={genericDelete(EXTENSION)}
        addButtonText={"Nova Operação"} 
        searchButtonText={"Procurar Operação"}
        tableConfigs={ConvencionaisConfig}
        dataBuildFunction={generalObjectBuilder(ConvencionaisConfig)}
        entityName={"Operações Convencionais"}
        idProp={"id"}
        configMapKey={`obras/${obraId}/pecas/${pecaId}/operacoes/Convencionais`}
        hidePagination
        hideFilters
        reroute={true}
        isSubTable
          />
    </div>:null}</>)


}